import { ConfirmationService } from 'primeng/primeng';
import { Injectable } from '@angular/core';
import { NecAlertData } from './alert-data';


@Injectable()
export class NecAlert {
  constructor(private confirmationService: ConfirmationService) {
  }

  /**
   * æ¾ç¤ºå¼¹æ¡æé
   */
  show(data: NecAlertData) {
    this.confirmationService.confirm({
      header: data.title,
      message: data.text,
      accept: data.accept,
      acceptLabel: data.acceptText || 'ç¡®å®',
      reject: data.reject,
      rejectLabel: data.rejectText || 'åæ¶'
    });

    setTimeout(() => {
      document.getElementById('alertAcceptBtn').innerText = data.acceptText ? data.acceptText : 'ç¡®å®';
      document.getElementById('alertRejectBtn').innerText = data.rejectText ? data.rejectText : 'åæ¶';
    });
  }
}
